/* The Overview's figure formatting — shared by the fan-bar tree
 * (FundOverviewTab) and the co-owned DAG (CoOwnedChain) so
 * the two drawings speak one canon (Ale 2026-09-03: the "m" short form,
 * no currency inside an instrument balance, the commitment package as one
 * figure block). */

import type { RtSegment } from '../RecordTable'

/** A figure as the diagram writes it: the "m" short form for a million and
 *  up, else the 2dp rule; a currency prefix only when asked. */
export function fmt(v: number | null | undefined, cur?: string | null): string {
  if (v === null || v === undefined) return '—'
  const body =
    Math.abs(v) >= 1_000_000
      ? `${(v / 1_000_000).toLocaleString('en-US', { maximumFractionDigits: 1 })}m`
      : v.toLocaleString('en-US', { maximumFractionDigits: 2 })
  return cur ? `${cur} ${body}` : body
}

/** The position's figures beside its amber wire. A commitment package is
 *  ONE position: the currency once, then committed · drawn (Ale, 3 Nov 2026). */
export function positionFigures(s: RtSegment): string {
  if (s.committed_amount !== null && s.committed_amount !== undefined) {
    const drawn = s.drawn_amount ?? null
    return `${fmt(s.committed_amount, s.units_currency)} committed · ${fmt(drawn)} drawn`
  }
  const units = fmt(s.units_held, s.units_currency)
  if (s.economic_pct !== null && s.economic_pct !== undefined)
    return `${units} · ${Math.round(s.economic_pct)}%`
  return `${units} · % unknown`
}
